import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { ThemeSettings } from "../../types/theme.js";
import { RichText } from "../../internal-components/rich-text/rich-text.js";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { getLinkProps } from "../../client-utils/getLinkProps.js";

interface Props {}

const Footer: React.FC<Props> = () => {
  const store = useStore<ThemeSettings>();
  const themeSettings = store.themeSettings;
  const footerLinks = themeSettings.footerLinks || [];
  const footerSocials = themeSettings.footerIcons || [];
  const footerText = themeSettings.footerText;
  const footerLogo = themeSettings.footerLogo;

  return (
    <footer className="footer">
      <div className="mw m-auto hs">
        <div className="footer-content">
          <div className="footer-top">
            {footerLogo && (
              <div className="footer-logo">
                <img
                  height="35px"
                  src={transformImageUrl(footerLogo, { height: 70 })}
                  alt="Lyskultur"
                />
              </div>
            )}

            {footerLinks.length > 0 &&
              footerLinks.map((item, i) => (
                <ul key={i} className="footer-menu">
                  <p className="menu-title b3">{item.title}</p>
                  {(item.links || []).map((linkItem, j) => {
                    if (!linkItem.link) {
                      return null;
                    }

                    const props = getLinkProps(linkItem.link);

                    return (
                      <li key={j}>
                        <a className="b3" {...props}>
                          {linkItem.link.title}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              ))}
          </div>
          <div className="divider" />
          <div className="footer-bottom">
            {footerText && <RichText html={footerText} />}
            {footerSocials.length > 0 && (
              <ul className="footer-socials">
                {footerSocials.map(({ link, icon }, i) => {
                  if (!link) return null;
                  const props = getLinkProps(link);

                  return (
                    <li key={i}>
                      {link?.url && (
                        <a {...props}>{icon && <span>{icon}</span>}</a>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
